import { useEffect, useRef, useState } from "react";
const MultipleCheckboxSelector = ({ type, defaultSelectedData, ItemLists, placeHolder, GetSelectedItems, clearFilter, setClearFilter}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const selectorRef = useRef(null);
    const searchInputRef = useRef(null);

    useEffect(() => {
        if (isOpen && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isOpen]);
    const handleSelectBarClick = () => {
        setIsOpen(!isOpen);
    };
    const handleItemClick = (item) => {
        const isSelected = selectedItems?.some(
            (selectedItem) => selectedItem?.value === item.value
        );

        if (isSelected) {
            let selectedData = selectedItems?.filter((selectedItem) => selectedItem?.value !== item.value);
            GetSelectedItems(selectedData);
            setSelectedItems(selectedData);
        } else {
            GetSelectedItems([...selectedItems, item]);
            setSelectedItems([...selectedItems, item]);
        }
    };
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };
    const listItems = ItemLists;
    const filteredItems = listItems?.filter((item) =>
        item?.display?.toLowerCase().includes(searchQuery?.toLowerCase())
    );
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (selectorRef.current && !selectorRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    useEffect(() => {
        if (clearFilter && clearFilter === true) {
            setSelectedItems([])
        }
        return () => {
            setClearFilter(false)
        };
    }, [clearFilter])
    useEffect(() => {
        setSelectedItems(defaultSelectedData || []);
    }, [defaultSelectedData]);
    return (
        <div className="claim_status">
            <div className="hk-SchedulerList" ref={selectorRef}>
                <div
                    className="hk-SchedulerList__selectBar"
                    onClick={handleSelectBarClick}
                >
                    <input
                        type="text"
                        placeholder={placeHolder}
                        value={selectedItems.map((item) => item?.display).join(", ")}
                    />
                    <i className={`icon-caret-${isOpen ? "up" : "down"}`}></i>
                </div>
                {isOpen && (
                    <div className="hk-SchedulerList__body">
                        <div className="hk-SchedulerList__body__searchBar">
                            <i className="bi bi-search"></i>
                            <input
                                ref={searchInputRef}
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="hk-SchedulerList__body__list custom_check_box">
                            {filteredItems?.map((item) => (
                                <div className="d-flex align-items-center"> 
                                    <div
                                        key={item?.value}
                                        className={`hk-SchedulerList__body__list__item ${selectedItems?.some(
                                            (selectedItem) =>
                                                selectedItem?.value === item?.value
                                        )
                                                ? "selected"
                                                : ""
                                            }`}
                                        onClick={() => handleItemClick(item)}
                                    >
                                        <label>
                                            <input
                                                className="form-check-input mt-2px p-0"
                                                type="checkbox"
                                                checked={selectedItems.some(
                                                    (selectedItem) =>
                                                        selectedItem?.value === item?.value
                                                )}
                                                onChange={() => handleItemClick(item)}
                                            />
                                        </label>
                                        <span>{item?.display}</span>
                                    </div>
                                     <div className={`${'ar_chekbox-circle '}${item?.color}`} style={{ backgroundColor:`${type === "AppointmentStatus" ? item.ColorCode : ''}`}}></div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MultipleCheckboxSelector;
